import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

const StoreConfigModalSubtitle = ({hasCurrencies, hasLocales}) => {
  if (hasCurrencies && hasLocales) {
    return (
      <FormattedMessage
        id="StoreConfigModal.subtitle.both"
        defaultMessage="Choose your preferred language and currency"
        tagName={React.fragment}
      />
    );
  } else if (hasCurrencies) {
    return (
      <FormattedMessage
        id="StoreConfigModal.subtitle.currency"
        defaultMessage="Choose your preferred currency"
        tagName={React.fragment}
      />
    );
  }

  return (
    <FormattedMessage
      id="StoreConfigModal.subtitle.locale"
      defaultMessage="Choose your preferred language"
      tagName={React.fragment}
    />
  );
};

StoreConfigModalSubtitle.propTypes = {
  hasCurrencies: PropTypes.bool,
  hasLocales: PropTypes.bool,
};

export default StoreConfigModalSubtitle;
